import type { SettingsKey } from '../../domain/settings';
import {
  AUTO_OPEN_LINKEDIN_KEY,
  ENABLE_TOOLS_KEY,
  ENABLE_CRM_KEY,
  ENABLE_EVERYWHERE_KEY,
  ENABLE_GCALENDAR_KEY,
  ENABLE_GMAIL_KEY,
} from '../../domain/settings';
import { useDispatchTrackEventWithLocation } from '../../services/tracking/hooks/useDispatchTrackEventWithLocation';

const TRACKING_KEYS = {
  [AUTO_OPEN_LINKEDIN_KEY]: 'auto open',
  [ENABLE_EVERYWHERE_KEY]: 'everywhere',
  [ENABLE_TOOLS_KEY]: 'tools',
  [ENABLE_CRM_KEY]: 'crm',
  [ENABLE_GCALENDAR_KEY]: 'google calendar meeting',
  [ENABLE_GMAIL_KEY]: 'gmail assistant',
};

export const useSettingsTracking = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTracking = (action: string, eventName: string) => {
    dispatchTrackEventWithLocation('extension top actions', action, eventName);
  };

  const handleTrackAccountClick = () => {
    handleTracking('open account settings', 'extension settings/links/account settings');
  };

  const handleTrackTermsClick = () => {
    handleTracking('open terms and conditions', 'extension settings/links/terms and condition');
  };

  const handleTrackSupportClick = () => {
    handleTracking('open knowlege center', 'extension settings/links/knowledge center');
  };

  const handleFeedbackClick = () => {
    handleTracking('open feedback form', 'extension settings/links/feedback form');
  };

  const handleUpgradePackageClick = (
    remainingAiInsightsQuota: number,
    remainingContactsQuota: number,
    remainingOverviewQuota?: number
  ) => {
    dispatchTrackEventWithLocation(
      'hooks',
      'upgrade package',
      `${remainingOverviewQuota || ''}/${remainingAiInsightsQuota}/${remainingContactsQuota}`
    );
  };

  const handleTrackSettingsChange = (key: SettingsKey, value: boolean) => {
    if (key in TRACKING_KEYS) {
      const trackingName = TRACKING_KEYS[key as keyof typeof TRACKING_KEYS];
      handleTracking(
        value ? `enable ${trackingName}` : `disable ${trackingName}`,
        `extension settings/${trackingName}/${value ? 'enable' : 'disable'}`
      );
    }
  };

  return {
    handleTrackAccountClick,
    handleTrackTermsClick,
    handleTrackSupportClick,
    handleTrackSettingsChange,
    handleUpgradePackageClick,
    handleFeedbackClick,
  };
};
